var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('ul',_vm._l((_vm.nav),function(item,index){return _c('li',{key:index,staticClass:"nav-item"},[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.title))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }